import { Skeleton, Tabs } from 'antd';
import ProductItem from './ProductItem';
import Pagination from '../Pagination';

import Empty from '../Empty';
import isEmpty from 'lodash/isEmpty';
import ShopifyProductItem from './ShopifyProductItem';
import styles from './index.module.scss';

export default function Products({ products, shopifyProducts, isMobile = false, onPageChange, currentPage }: any) {
    const handlePageChange = (page: any) => {
        onPageChange && onPageChange(page);
    };
    return (
        <>
            {!isEmpty(products?.content) ? (
                <div className="aiSearchProductsContainer">
                    {products?.content?.map((product: any) => (
                        <ProductItem product={product.content} key={product.id} isMobile={isMobile} />
                    ))}
                    {products?.total > 8 && (
                        <div className="aiSearchProductsPagination">
                            <Pagination current={currentPage} total={products?.total} pageSize={8} onChange={handlePageChange} />
                        </div>
                    )}
                </div>
            ) : (
                <Empty isMobile={isMobile} />
            )}
            {!isEmpty(shopifyProducts?.content) && (
                <div className={`${products?.total <= 8 ? styles.aiShopifyProductsContainer : ''} aiSearchProductsContainer`}>
                    {shopifyProducts?.content?.slice(0, 4)?.map((product: any) => (
                        <ShopifyProductItem product={product} key={product.variantId} isMobile={isMobile} />
                    ))}
                </div>
            )}
        </>
    );
}
